var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 79,
    viewBox: "0 0 76 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9075 24.8698L31.935 47.7397L19.9692 36.3048M2 29.2396V5.26712C2 4.40063 2.34421 3.56962 2.95692 2.95692C3.56962 2.34421 4.40063 2 5.26712 2H70.6095C71.476 2 72.307 2.34421 72.9197 2.95692C73.5324 3.56962 73.8767 4.40063 73.8767 5.26712V29.2396C73.8767 63.5444 44.7584 74.8976 38.9593 76.817C38.3005 77.061 37.5761 77.061 36.9174 76.817C31.1182 74.8976 2 63.5444 2 29.2396Z",
    stroke: "url(#paint0_linear_554_1445)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1445",
    x1: 37.9383,
    y1: 2,
    x2: 37.9383,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4063B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704BA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityIcon);
export default __webpack_public_path__ + "static/media/quality_icon.86ccc72737841daf3f46339c47372e3c.svg";
export { ForwardRef as ReactComponent };